var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"dropdown-item tw-p-3 tw-text-gray-text hover:tw-bg-gray-0 tw-rounded tw-cursor-pointer",class:{'active': _vm.selected}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }